exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".objectView[data-v-34e2cd94]{height:200px;display:flex;flex-direction:column;align-items:center;background-color:#333;margin:10px;border-radius:5px;border:1px solid transparent}.objectView h3[data-v-34e2cd94]{text-align:center}a.nostyle[data-v-34e2cd94]:link,a.nostyle[data-v-34e2cd94]:visited{text-decoration:inherit;color:inherit}@media only screen and (min-width:768px){.objectView[data-v-34e2cd94]:hover{border:1px solid #eee;background-color:#222}}@media only screen and (max-width:768px){.objectView h3[data-v-34e2cd94]{font-size:16px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34e2cd94","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ObjectView.vue
// module id = 35
// module chunks = 0